import { EmcIdlePeriodDto } from '../installation/api'
import { BlockingWeeklySchedule } from '../installation/forms'
import { formatDateToHours } from '../installation/utils'

export const blockingWeeklySheduleToEmcIdlePeriodDto = (schedule: BlockingWeeklySchedule, mode: EmcIdlePeriodDto['mode']): EmcIdlePeriodDto => {
  return {
    from: formatDateToHours(schedule.fromTime),
    to: formatDateToHours(schedule.toTime),
    days: {
      mo: schedule.weekDays.monday ?? false,
      tu: schedule.weekDays.tuesday ?? false,
      we: schedule.weekDays.wednesday ?? false,
      th: schedule.weekDays.thursday ?? false,
      fr: schedule.weekDays.friday ?? false,
      sa: schedule.weekDays.saturday ?? false,
      su: schedule.weekDays.sunday ?? false,
    },
    mode,
  }
}
